import {
  Box,
  Stack,
  Heading,
  StatGroup,
  Stat,
  Flex,
  Text,
  StatLabel,
  StatNumber,
  StatHelpText,
} from '@chakra-ui/react'
import numeral from 'numeral'

import PeopleChart from 'src/components/PeopleChart'
import { sum } from 'src/lib/utils'
import CellLoading from 'src/components/CellLoading'
import SchoolListDownloadButton from 'src/components/FullDashboardCell/SchoolListDownloadButton'
import CookieAnalyticsSection from 'src/components/FullDashboardCell/CookieAnalyticsSection'

import { PackageChart } from './PackageChart'
import { gql } from '@apollo/client'

export const QUERY = gql`
  query {
    dashboard: fullDash {
      sessions {
        count
      }
      people {
        type
        count
      }
      contents {
        type
        count
      }
      people30days {
        type
        count
      }
      schools {
        count
      }
      packages {
        type
        count
      }
      cookieAnalytics {
        type
        count
      }
      cmsActiveSites {
        count
      }
    }
  }
`

export const beforeQuery = (props) => {
  return { variables: props, fetchPolicy: 'cache-and-network' }
}

export const Loading = CellLoading

export const Empty = () => <div>Empty</div>

export const Failure = ({ error }) => <div>Error: {error.message}</div>

export const Success = ({ dashboard }) => {
  const {
    sessions,
    contents,
    schools,
    people,
    people30days,
    packages,
    cookieAnalytics = [],
    cmsActiveSites = [],
  } = dashboard
  const cmsSiteCount = cmsActiveSites[0]?.count ?? 0
  return (
    <Stack
      padding={5}
      width="100%"
      height="calc(100vh - 5.4rem)"
      overflowY="auto"
    >
      <Box>
        <Heading size="lg" fontWeight={400}>
          Stats
        </Heading>
        <StatGroup padding={5}>
          <Stat>
            <StatLabel>People</StatLabel>
            <StatNumber>{numeral(sessions[0].count).format()}</StatNumber>
            <StatHelpText>logged in last year</StatHelpText>
          </Stat>
          <Stat>
            <StatLabel>Total Schools</StatLabel>
            <StatNumber>{numeral(schools[0].count).format()}</StatNumber>
          </Stat>
        </StatGroup>
      </Box>
      <Box width="100%">
        <Heading size="lg" fontWeight={400}>
          Package
        </Heading>
        <Text fontSize="0.9rem" color="gray.400">
          used by schools
        </Text>
        <Box height={90}>
          <PackageChart packages={packages} name="schools" />
        </Box>
        <SchoolListDownloadButton packages={packages} />
      </Box>
      <Box marginTop={12} marginBottom={14}>
        <Heading size="lg" fontWeight={400} marginTop={6} marginBottom={8}>
          Cookies & Analytics
        </Heading>
        <CookieAnalyticsSection
          cookieAnalytics={cookieAnalytics}
          totalSites={cmsSiteCount}
        />
      </Box>
      <Box>
        <Heading size="lg" fontWeight={400}>
          Content
        </Heading>
        <Text fontSize="0.9rem" color="gray.400">
          Created in last 1 year
        </Text>
        <StatGroup padding={5}>
          {contents.map((c, idx) => {
            return (
              <Stat key={idx}>
                <StatLabel>{c.type}</StatLabel>
                <StatNumber>{numeral(c.count).format()}</StatNumber>
              </Stat>
            )
          })}
        </StatGroup>
      </Box>
      <Heading size="lg" fontWeight={400}>
        People
      </Heading>
      <Flex justifyContent="space-evenly" flexWrap="wrap">
        <Box height={500} width={500}>
          <Heading size="md" fontWeight={100} textAlign="center">
            Total {numeral(people.reduce(sum, 0)).format()}
          </Heading>
          <PeopleChart people={people} />
          <br />
        </Box>
        <Box height={500} width={500}>
          <Heading size="md" fontWeight={100} textAlign="center">
            {numeral(people30days.reduce(sum, 0)).format()} active in last 30
            days
          </Heading>
          <PeopleChart people={people30days} />
          <br />
        </Box>
      </Flex>
    </Stack>
  )
}
